const applySupplierSettings = {
  status: true,
  time: true,
  error_code: true,
  error: true,
};

export {applySupplierSettings}